import { useReactFlow } from '@xyflow/react'
import { ProcessFlowDiagramBuilderContext } from 'features/processFlowDiagrams/contexts/ProcessFlowDiagramBuilderContext'
import { ArrowLeftRight, Check } from 'lucide-react'
import { useContext } from 'react'
import styled from 'styled-components'
import { PfdEdge } from 'types'

const EdgeButton = styled.button`
  width: 30px;
  height: 30px;
  border: 3px solid ${({ theme }) => theme.forecast.background1};
  color: ${({ theme }) => theme.forecast.activeText};
  background-color: ${({ theme }) =>
    theme.forecast.cardBackground || theme.forecast.background2};
  cursor: pointer;
  border-radius: 50%;
  font-size: 12px;
  padding-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background3};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`

const EdgeLabel = styled.div<{ $labelX: number; $labelY: number }>`
  position: absolute;
  pointer-events: all;
  transform-origin: center;
  transform: translate(-50%, -50%)
    translate(${({ $labelX }) => $labelX}px, ${({ $labelY }) => $labelY}px);
  display: flex;
  gap: 4px;
  align-items: center;
`

export const SwapEdgeButton = ({
  labelX,
  labelY,
  id,
}: {
  labelX: number
  labelY: number
  id: string
}) => {
  const { setEdges } = useReactFlow()
  const context = useContext(ProcessFlowDiagramBuilderContext)

  // Don't render buttons if editing is not allowed or context is not available
  if (!context || !context.inEditMode) {
    return null
  }

  const onEdgeConfirm = () => {
    setEdges((edges: PfdEdge[]) =>
      edges.map((edge) =>
        edge.id === id
          ? { ...edge, data: { ...edge.data, confirmedEdge: true } }
          : edge
      )
    )
  }
  const onEdgeClick = () => {
    setEdges((edges: PfdEdge[]) =>
      edges.map((edge) =>
        edge.id === id
          ? {
              ...edge,
              type: edge.type === 'dashedLine' ? 'solidLine' : 'dashedLine',
            }
          : edge
      )
    )
  }
  return (
    <EdgeLabel $labelX={labelX} $labelY={labelY}>
      <EdgeButton onClick={onEdgeClick}>
        <ArrowLeftRight size={12} />
      </EdgeButton>
      <EdgeButton onClick={onEdgeConfirm}>
        <Check size={12} />
      </EdgeButton>
    </EdgeLabel>
  )
}
